const Ajax = require('common/infra/ajax');

class API {
    get() {
        return Ajax.GET(`/api/app`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./common/infra/api/app-info.js